import { render, staticRenderFns } from "./LECO_Footer.vue?vue&type=template&id=39515a72&scoped=true&"
import script from "./LECO_Footer.vue?vue&type=script&lang=js&"
export * from "./LECO_Footer.vue?vue&type=script&lang=js&"
import style0 from "./LECO_Footer.vue?vue&type=style&index=0&id=39515a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39515a72",
  null
  
)

export default component.exports